<form
  [formGroup]="form"
  (ngSubmit)="confirm()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div class="flex w-full justify-between gap-4 py-4 border-b border-neutral-300">
      <span class="text-[18px] font-black">
        <i
          class="pi pi-file-edit"
          style="font-size: 2rem"></i>
        SUBSANACION DE DESPLIEGUE DE SISTEMA
      </span>
      <div class="flex gap-4">
        <app-buttons
          [label]="'Detalle de subsanación'"
          (click)="goToSummary()" />
        <app-buttons
          [label]="'Volver al paso anterior'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Continuar'"
          [disabled]="form.invalid || hasPendingObservedFieldsInStep()"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 3 de 6</span>
      <h2 class="font-bold text-[24px] pb-6">Cuestiones Técnicas</h2>

      <h3 class="font-bold text-[18px] pb-6">Alojamiento</h3>

      <div class="flex flex-col relative">
        <label
          class="text-[16px]"
          for="aiInfrastructure"
          [ngClass]="{ 'relative -top-4': isObserved('aiInfrastructure') }">
          Infraestructura
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('aiInfrastructure')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="aiInfrastructure"
        placeholder="Escriba aquí información sobre la infraestructura"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>

      <h3 class="font-bold text-[18px] py-6">Integración</h3>

      <div class="flex flex-col relative">
        <label
          class="text-[16px]"
          for="integrationMode"
          [ngClass]="{ 'relative -top-4': isObserved('integrationMode') }">
          Modo de integración con la plataforma corporativa
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('integrationMode')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="integrationMode"
        placeholder="Escriba aquí el modo de integración con la plataforma corporativa"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="500"></desy-textarea>
      <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 500 caracteres</span>

      <h3 class="font-bold text-[18px] py-6">Datos de entrenamiento</h3>

      <div class="flex flex-col relative">
        <label
          class="text-[16px]"
          for="dataSource"
          [ngClass]="{ 'relative -top-4': isObserved('dataSource') }">
          Origen de los datos
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('dataSource')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="dataSource"
        placeholder="Escriba aquí el origen de los datos"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="500"></desy-textarea>
      <ng-container *ngIf="getError(form, 'dataSource', formSubmitted()) as error; else dataSourceInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #dataSourceInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 500 caracteres</span>
      </ng-template>

      <div class="flex flex-col relative pt-4">
        <label
          class="text-[16px]"
          for="timePeriod"
          [ngClass]="{ 'relative -top-4': isObserved('timePeriod') }">
          Periodo temporal cubierto
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('timePeriod')"
          class="absolute top-6 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="timePeriod"
        placeholder="Escriba aquí el periodo temporal cubierto"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'timePeriod', formSubmitted()) as error; else timePeriodInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #timePeriodInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>

      <div class="grid grid-cols-2 items-end mt-4">
        <div class="relative">
          <label
            class="text-[16px] mb-2 block"
            [ngClass]="{ 'relative -top-4': isObserved('dataCategory') }">
            Tipo de datos*
          </label>
          <app-observed-field-alert
            *ngIf="isObserved('dataCategory')"
            class="absolute top-2 left-0"></app-observed-field-alert>
          <p-multiSelect
            formControlName="dataCategory"
            [options]="dataCategoryOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Selecciona una o más categorías"
            [showToggleAll]="false"
            [showHeader]="false"
            styleClass="w-full"></p-multiSelect>
        </div>

        <div></div>

        <div class="flex flex-col relative">
          <label
            class="text-[16px] mt-6 block"
            for="qualityAccreditation"
            [ngClass]="{ 'relative -top-4': isObserved('qualityAccreditation') }">
            Acreditación de la calidad de los datos
            <span *ngIf="highRiskFieldsRequired()">*</span>
          </label>
          <app-observed-field-alert
            *ngIf="isObserved('qualityAccreditation')"
            class="absolute top-8 left-0"></app-observed-field-alert>
          <span class="text-[14px] text-neutral-dark block">Con CSV</span>
          <desy-input
            id="qualityAccreditation"
            [classes]="'w-full'"
            [placeholder]="'Supervisor-1, Supervisor-2...'"
            formControlName="qualityAccreditation"></desy-input>
          <desy-error-message *ngIf="getError(form, 'qualityAccreditation', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <div class="flex flex-col relative pt-4">
        <label
          class="text-[16px]"
          for="inputDataSource"
          [ngClass]="{ 'relative -top-4': isObserved('inputDataSource') }">
          Origen de la fuente de datos en tiempo real
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('inputDataSource')"
          class="absolute top-6 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="inputDataSource"
        placeholder="Escriba aquí el origen de la fuente de datos en tiempo real"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="500"></desy-textarea>
      <ng-container *ngIf="getError(form, 'inputDataSource', formSubmitted()) as error; else inputDataSourceInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #inputDataSourceInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 500 caracteres</span>
      </ng-template>

      <h3 class="font-bold text-[18px] py-6">Código</h3>

      <div class="flex flex-col relative">
        <label
          class="text-[16px]"
          for="sourceCode"
          [ngClass]="{ 'relative -top-4': isObserved('sourceCode') }">
          Enlace al código fuente
          <span *ngIf="highRiskFieldsRequired()">*</span>
        </label>
        <app-observed-field-alert
          *ngIf="isObserved('sourceCode')"
          class="absolute top-2 left-0"></app-observed-field-alert>
      </div>
      <desy-textarea
        formControlName="sourceCode"
        placeholder="Escriba aquí el enlace al código fuente"
        classes="w-full text-[16px]"
        class="w-full"
        [rows]="3"
        [maxlength]="200"></desy-textarea>
      <ng-container *ngIf="getError(form, 'sourceCode', formSubmitted()) as error; else sourceCodeInfo">
        <desy-error-message>
          {{ error }}
        </desy-error-message>
      </ng-container>
      <ng-template #sourceCodeInfo>
        <span class="text-[14px] text-neutral-dark info-message">Puedes escribir hasta 200 caracteres</span>
      </ng-template>
    </div>
  </div>
</form>
